import { render, staticRenderFns } from "./FormContaBancaria.vue?vue&type=template&id=1c5214a6"
import script from "./FormContaBancaria.vue?vue&type=script&lang=js"
export * from "./FormContaBancaria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports